import axios from "axios";
import {
    DASHBOARD_FILTER_DETAILS_REQUEST,
    DASHBOARD_FILTER_DETAILS_SUCCESS,
    DASHBOARD_FILTER_DETAILS_ERROR,
    SET_SCENARIO_GROUP_AND_BENCH_NAME_REQUEST,
    SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR,
    SET_TAG_NAME_ARRANGE_SCENARIO_GROUP_IDS,
    SET_SCENARIO_GROUP_ID_ARRANGE_BENCH_NAMES,
    SET_SCENARIO_GROUP_NAME_ARRANGE_BENCH_NAMES,
    SET_SCENARIO_GROUP_NAME_WITH_ID_ARRANGE_BENCH_NAMES,
    SET_BENCH_NAME_ARRANGE_RUN_IDS,
    SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_REQUEST,
    SET_RUN_ID_ARRANGE_SCENARIO_UUIDS,
    SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR,
    SET_SCENARIO_UUID_AND_DESCRIPTION,
    SET_FORM_FILTER_DATA_RESET,
} from "./../../../constants/closeLoop/kpiDashboard/dashboardConstants";

export const fetchKPIDashboardInputData = () => (dispatch) => {
    try {
        dispatch({ type: DASHBOARD_FILTER_DETAILS_REQUEST });
        // const url = '/close_loop/performance_report/filter_data/';
        const mongoUrl = "/close_loop/kpi/dashboard/fetch/mongo/tag_names";
        axios
            .get(mongoUrl)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    console.log(data);
                    dispatch({ type: DASHBOARD_FILTER_DETAILS_SUCCESS, payload: data });
                } else {
                    const { data } = response;
                    dispatch({
                        type: DASHBOARD_FILTER_DETAILS_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // dispatch({
                //   type: DASHBOARD_FILTER_DETAILS_ERROR,
                //   payload: error.response.data.message,
                // });
                // if(error.hasOwnProperty("response") && error.response.hasOwnProperty("data")
                //   && error.response.data.hasOwnProperty("message")){
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: DASHBOARD_FILTER_DETAILS_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: DASHBOARD_FILTER_DETAILS_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: DASHBOARD_FILTER_DETAILS_ERROR, payload: error.message });
    }
};

export const updateTagNameAndScenarioGroupIds = (payload) => (dispatch) => {
    try {
        const { tag_name } = payload;
        dispatch({ type: SET_SCENARIO_GROUP_AND_BENCH_NAME_REQUEST });
        const url = "/close_loop/kpi/dashboard/fetch/mongo/scenario_group_and_bench_name";
        axios
            .post(url, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    console.log(response.data);
                    if (response.data["message"] === "success") {
                        dispatch({
                            type: SET_TAG_NAME_ARRANGE_SCENARIO_GROUP_IDS,
                            payload: response.data,
                            tagName: tag_name,
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // dispatch({
                //   type: SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR,
                //   payload: error.response.data.message,
                // });
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({
            type: SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR,
            payload: error.message,
        });
    }
};

export const updateScenarioGroupIdAndBenchNames = (scenarioGroupId) => (dispatch) => {
    dispatch({
        type: SET_SCENARIO_GROUP_ID_ARRANGE_BENCH_NAMES,
        payload: scenarioGroupId,
    });
};

export const updateScenarioGroupNameAndBenchNames = (scenarioGroupName) => (dispatch) => {
    dispatch({
        type: SET_SCENARIO_GROUP_NAME_ARRANGE_BENCH_NAMES,
        payload: scenarioGroupName,
    });
};

export const updateScenarioGroupNameWithIdAndBenchNames =
    (scenarioGroupNameWithId) => (dispatch) => {
        /* Action dispatcher to update the redux store of "kpi form data" with
         * with selected tag name and filter the associated scenario group name & group id
         * information */
        dispatch({
            type: SET_SCENARIO_GROUP_NAME_WITH_ID_ARRANGE_BENCH_NAMES,
            payload: scenarioGroupNameWithId,
        });
    };

export const updateBenchNameAndRunIds = (benchName) => (dispatch) => {
    dispatch({ type: SET_BENCH_NAME_ARRANGE_RUN_IDS, payload: benchName });
};

export const updateRunIdAndScenarioIds = (runId, info) => (dispatch) => {
    try {
        dispatch({ type: SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_REQUEST, runId: runId });

        // const url = '/close_loop/kpi/dashboard/fetch/scenario_info'
        const mongoUrl = "/close_loop/kpi/dashboard/fetch/mongo/scenario_info";
        axios
            .post(mongoUrl, info)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    console.log(response);
                    if (data.message === "success") {
                        const { records } = data;
                        dispatch({
                            type: SET_RUN_ID_ARRANGE_SCENARIO_UUIDS,
                            runId: runId,
                            payload: records,
                        });
                    } else {
                        dispatch({
                            type: SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR,
                            runId: runId,
                            payload: data.message,
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR,
                        runId: runId,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                error.response.data.message
                    ? dispatch({
                          type: SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR,
                          runId: runId,
                          payload: error.response.data.message,
                      })
                    : dispatch({
                          type: SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR,
                          runId: runId,
                          payload: `Error Occurred while fetching this test_run_id : ${runId}`,
                      });
            });
    } catch (error) {
        console.log(error);
        dispatch({
            type: SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR,
            runId: runId,
            payload: error.message,
        });
    }
};

export const updateScenarioUUIDAndDescription = (scenarioUUID) => (dispatch) => {
    dispatch({
        type: SET_SCENARIO_UUID_AND_DESCRIPTION,
        payload: scenarioUUID,
    });
};

export const resetFilterFormData = () => (dispatch) => {
    dispatch({ type: SET_FORM_FILTER_DATA_RESET });
};
